export default {
  data() {
    return {
      formSubmissionsDropdownData: {
        mobileDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortFormSubmissions(
                    this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.order.col,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortFormSubmissions(
                    this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.order.col,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        sortMainColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            key: "created_at",
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortFormSubmissions("created_at", "ASC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortFormSubmissions("created_at", "DESC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        filterDropdown: [
          {
            title: this.$t("filters.filterForms"),
            options: [
              {
                label: this.$t("filters.fromProject"),
                select: {
                  name: "project",
                  multiple: false,
                  model: null,
                  options: [],
                  label: "label",
                  placeholder: this.$t("placeholders.selectProject"),
                  wrap: true,
                  searchable: true,
                  searchChange: () => {},
                },
                method: () => {},
                checkbox: true,
                hoverBg: true,
                hideIfNoOptions: true,
              },
              {
                label: this.$t("filters.fromClient"),
                select: {
                  name: "client",
                  multiple: false,
                  model: null,
                  options: [],
                  label: "label",
                  placeholder: this.$t("placeholders.selectClient"),
                  wrap: true,
                  searchable: true,
                  searchChange: () => {},
                },
                method: () => {},
                checkbox: true,
                hoverBg: true,
                hideIfNoOptions: true,
              },
              {
                label: this.$t("filters.activateFilter"),
                border: "border-top",
                color: "primary",
                position: "center",
                method: () => {
                  this.setFormSubmissionsFilters();
                },
                noActiveState: true,
                button: true,
              },
              {
                label: this.$t("filters.resetFilter"),
                color: "text-danger",
                position: "center",
                method: () => {
                  this.resetFilters(this.setFormSubmissionsFilters);
                },
                hoverBg: true,
                noActiveState: true,
              },
            ],
          },
        ],
      },
      projectFormSubmissionsDropdownData: {
        mobileDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortProjectFormSubmissions(
                    this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.order.col,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortProjectFormSubmissions(
                    this.teamsSettings[this.$route.params.team].listsSettings.formSubmissions.order.col,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        sortMainColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            key: "created_at",
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortProjectFormSubmissions("created_at", "ASC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortProjectFormSubmissions("created_at", "DESC");
                },
                icon: "Icon=check.svg",
                hoverBg: true,
              },
            ],
          },
        ],
        filterDropdown: [
          {
            title: this.$t("filters.filterForms"),
            options: [
              {
                label: this.$t("filters.fromForm"),
                select: {
                  name: "fieldset",
                  multiple: false,
                  model: null,
                  options: [],
                  label: "label",
                  placeholder: this.$t("placeholders.selectForm"),
                  wrap: true,
                  searchable: true,
                  searchChange: () => {},
                },
                method: () => {},
                checkbox: true,
                hoverBg: true,
                hideIfNoOptions: true,
              },
              {
                label: this.$t("filters.fromClient"),
                select: {
                  name: "client",
                  multiple: false,
                  model: null,
                  options: [],
                  label: "label",
                  placeholder: this.$t("placeholders.selectClient"),
                  wrap: true,
                  searchable: true,
                  searchChange: () => {},
                },
                method: () => {},
                checkbox: true,
                hoverBg: true,
                hideIfNoOptions: true,
              },
              {
                label: this.$t("filters.activateFilter"),
                border: "border-top",
                color: "primary",
                position: "center",
                method: () => {
                  this.setProjectFormSubmissionsFilters();
                },
                noActiveState: true,
                button: true,
              },
              {
                label: this.$t("filters.resetFilter"),
                color: "text-danger",
                position: "center",
                method: () => {
                  this.resetFilters(this.setProjectFormSubmissionsFilters);
                },
                hoverBg: true,
                noActiveState: true,
              },
            ],
          },
        ],
      },
    };
  },
};
